import * as InfoBarActionTypes from 'actiontypes/infoBar';
import InfoBarService from 'services/InfoBarService';

const service = new InfoBarService();

/** ----------------------------------------------------------------------------
 * FETCH MORE SNIPPETS
 -----------------------------------------------------------------------------*/

export const fetchSnippets = () => async (dispatch) => {
  dispatch(fetchSnippetsRequested());

  try {
    const { data } = await service.fetchSnippets();
    dispatch(fetchSnippetsSuccess(data));
  } catch (error) {
    dispatch(fetchSnippetsFailure(error));
  }
};

export const fetchSnippetsRequested = () => ({
  type: InfoBarActionTypes.FETCH_SNIPPETS_REQUESTED,
  isSuccess: false,
});

export const fetchSnippetsSuccess = data => ({
  type: InfoBarActionTypes.FETCH_SNIPPETS_SUCCESS,
  isSuccess: true,
  payload: {
    snippets: data,
  },
});

export const fetchSnippetsFailure = error => ({
  type: InfoBarActionTypes.FETCH_SNIPPETS_FAILURE,
  status: error.response && error.response.status,
});

/** ----------------------------------------------------------------------------
* SNIPPETS SETUP
-----------------------------------------------------------------------------*/

export const getSupportingData = () => (dispatch) => {
  dispatch(getSupportingDataRequested());

  return service.getSupportingData().then(
    response => dispatch(getSupportingDataSuccess(response.data)),
    error => dispatch(getSupportingDataFailure(error)),
  );
};

export const getSupportingDataSuccess = ({ advert, snippets }) => ({
  type: InfoBarActionTypes.SUPPORTING_DATA_SUCCESS,
  payload: { advert, snippets },
  isFetching: false,
});

export const getSupportingDataRequested = () => ({
  type: InfoBarActionTypes.SUPPORTING_DATA_REQUESTED,
  isFetching: true,
});

export const getSupportingDataFailure = () => ({
  type: InfoBarActionTypes.SUPPORTING_DATA_FAILURE,
  isFetching: false,
});